export default "<div>\r\n    <div data-bind=\"component: { name: 'tax-forms-list'}\"></div>\r\n</div>";